module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "innerpage_content_wrap"
  }, [_c('div', {
    staticClass: "container_manual clearfix"
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "page_titlee"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  })]), _c('div', {
    staticClass: "page_content"
  }, [_c('div', {
    staticClass: "blog_bar_outer clearfix"
  }, [_c('h3', {
    staticClass: "blog_date_bar"
  }, [_c('span', {
    staticClass: "date",
    domProps: {
      "innerHTML": _vm._s("<span>" + _vm.props.date.slice(8, 10) + "</span>/<span>" + _vm.props.date.slice(5, 7) + "</span>/<span>" + _vm.props.date.slice(0, 4) + "</span>")
    }
  })]), (_vm.props.better_featured_image) ? _c('div', {
    staticClass: "blog_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.better_featured_image.source_url
    }
  })]) : _vm._e(), (_vm.props.content) ? _c('div', {
    staticClass: "blog_excrept_content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  }) : _vm._e()])])])])]), _c('FooterMain')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637d1f48","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/blog-post/blog-post.pug
// module id = 642
// module chunks = 1